import React from 'react'
import { getSessionMerchantInfo } from '@merchant-backend/util'
import style from '../index.module.less'
import store from '../../store'

export default [
  {
    title: '套餐',
    dataIndex: 'name',
    key: 'name',
    render: (text, record) => (
      <div>
        <dl className={style.work}>
          <dt>
            <cite
              style={{
                display:
                  record.status == 0 || record.status == 3
                    ? 'inline-block'
                    : 'none'
              }}
              className={style.citeI}
            >
              {record.status == 0
                ? '审核中'
                : record.status == 3
                  ? '未通过审核'
                  : ''}
            </cite>
            <img
              style={{ width: 100, height: 62 }}
              src={record.cover_path + '?imageView2/1/w/100/h/62'}
            />
            <img
              style={{
                display: record.is_installment == 1 ? 'inline-block' : 'none'
              }}
              className={style.installImg}
              src="http://qnm.hunliji.com/o_1appksj00tto1gqq1dqudfq1sa77.png"
            />
            {record.base_price == 0 &&
              getSessionMerchantInfo().is_new_si_da == 1 && (
                <img
                  className={style.installImg}
                  src="http://qnm.hunliji.com/o_1bhjt5r38klg29u1uso43629n7.png"
                />
              )}
          </dt>
          <dd>
            <h5>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={
                  '/p/wedding/Web/Detail/detail/type/package/id/' +
                  record.id +
                  '/admin/true'
                }
              >
                {record.title}
              </a>
            </h5>
          </dd>
        </dl>
        <p
          style={{
            display:
              store.key == 2 || store.key == 4
                ? record.reason == '' || record.reason == null
                  ? 'none'
                  : 'block'
                : 'none'
          }}
          className={style.tipBox}
        >
          <span />
          {record.status == 3 ? '未通过原因:' : ''}
          {record.status == 3 && record.reason}
        </p>
      </div>
    )
  },
  {
    title: '套餐类型',
    dataIndex: 'second_category',
    key: 'second_category',
    render: (second_category, record) => (
      <div>{(second_category || {}).title}</div>
    )
  },
  {
    title: '价格',
    dataIndex: 'price',
    key: 'price',
    render: (text, record) => (
      <div>
        <p>{record.actual_price}</p>
        {record.earnest_money != 0 && (
          <p className="hlj-red1" style={{ color: '#ff5c5c' }}>
            定金:{record.earnest_money ? record.earnest_money : '-'}
          </p>
        )}
      </div>
    )
  },
  {
    title: '售出数',
    dataIndex: 'sale',
    key: 'sale',
    render: (text, record) => (
      <div>{record.sales_count ? record.sales_count : '-'}</div>
    )
  },
  {
    title: '收藏数',
    dataIndex: 'num',
    key: 'num',
    render: (text, record) => (
      <div>{record.collectors_count ? record.collectors_count : '-'}</div>
    )
  },
  {
    title: '上架时间',
    dataIndex: 'publish',
    key: 'publish',
    render: (text, record) => <div>{record.updated_at}</div>
  },
  {
    title: '操作',
    dataIndex: 'edit',
    key: 'edit',
    render: (
      text,
      record //第一个tab和最后一个tab分上架下架，其他根据is_sold_out判断
    ) => (
      /*<a onClick={store.showModalFn(record.id,record.is_sold_out)} href="javascript:;">
             {store.key==1?'下架':store.key==5?'上架':record.is_sold_out==true?'上架':record.is_sold_out==false||record.is_sold_out==null?'下架':''}
             </a> href={`#/localMerchant/setMealEdit/${record.id}`}*/
      <div>
        <p>
          <a
            style={{ color: '#508cee' }}
            onClick={store.setMealEditFn(record.id, record.is_rule)}
            href="javascript:;"
          >
            编辑
          </a>
        </p>
        <p>
          <a
            style={{ color: '#508cee' }}
            onClick={store.showModalFn(record.id, record.is_sold_out, 2)}
            href="javascript:;"
          >
            {record.is_sold_out == true
              ? '上架'
              : record.is_sold_out == false || record.is_sold_out == null
                ? '下架'
                : ''}
          </a>
        </p>
        <p>
          <a
            style={{ color: '#ff5c5c' }}
            onClick={store.showModalFn(record.id, 'del', 2)}
            href="javascript:;"
          >
            删除
          </a>
        </p>
      </div>
    )
  }
]
